module.exports = __webpack_public_path__ + "media/images/lux-hotels-c2cc43a930b3df9bc696f71b49a55cd1.svg";